<template>
  <div class="backimg">
    <div class="search-content" style="width:100%;margin: 0 auto;">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item v-for="item in menuList"  :key="item.menuurl" :index="item.menuurl">{{item.menuname}}
        </el-menu-item>
      </el-menu>
      <div class="line"></div>
    </div>
    <el-main>
      <router-view :roletype="'yunyin'" v-if="visible"></router-view>
      <iframe width="100%" scrolling="Auto" :height="tableHeight(12)" frameborder="0" name="jiesuanframe" v-if="visibleframe"></iframe>
    </el-main>
  </div>
</template>
<script>
  import {countlist} from '@/api/set/csagreement';
  import {getMenu, checkModuleRight} from '@/api/login'

  export default {
    data() {
      return {
        activeIndex: "",
        visible: true,
        visibleframe:false,
        userInfoModel: [],
        financeright: false,//拥有财务权限
        menuList: [],//菜单
      };
    },
    methods: {
      handleSelect(key) {
        this.visible = false
        this.visibleframe = false;
        if (key.startsWith("frame:")) {
          this.visibleframe = true;
        }
        this.$nextTick(() => {
          if (key.startsWith("frame:")) {
            window.open('//' + window.location.host + key.replace("frame:", ""), 'jiesuanframe', false);
          } else {
            this.$router.push({name: key})
            this.visible = true
          }
        })
      },
      getMenuList() {
        getMenu({
          MenuCode: this.$route.params.menucode,
          AppGuid: (localStorage.getItem("appguid") || "")
        }).then(response => {
          this.menuList = response.data.menu
          var routn=this.menuList[0].menuurl
          this.activeIndex=routn;
          this.handleSelect(routn);
        }).catch((error) => {
          console.log(error)
        });
      }
    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
      // this.financeright = this.$checkRight("财务")
      this.getMenuList()
    },
    components: {}
  }
</script>
<style scoped>

  .el-main {
    padding: 0px;
    /*height: calc(100vh - 97px);*/
    width: 100%;
    margin: 0 auto;
    background-color: white;
    overflow: auto;
  }

  .el-menu-item {
    height: 48px !important;
    line-height: 48px !important;
  }

  .el-submenu__title, .el-submenu {
    height: 48px !important;
    line-height: 48px !important;
  }


</style>



// WEBPACK FOOTER //
// src/components/account/Yunyin.vue